// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__f-jUW","content":"LoadingAlert_content__302xE"};